// No emotion or hooks — rendered via ReactDOMServer.renderToString for Mapbox popups

import { truncateToNearestSpace } from '@app/utils/strings.utils'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'

const formatValue = (v: unknown): string => {
  if (v === null || v === undefined) return ''
  if (typeof v === 'object') return JSON.stringify(v)

  const truncatedValue = truncateToNearestSpace(String(v), 100)

  return truncatedValue
}

export const LivePopup = ({
  props,
  layerName,
  iconURL,
  primaryColour = '#0B2948',
  stackedCount,
}: {
  props: { label: string; value: string | number; type?: string }[]
  layerName: string
  layerId: string
  primaryColour?: string
  iconURL?: string
  stackedCount?: number
}) => {
  const resolvedIconURL =
    iconURL ?? `${PUBLIC_ASSETS_BASE_URL}/icons/live_feeds/default/default.svg`

  return (
    <div
      className="tooltip-container"
      style={{
        padding: '4px 0',
        backgroundColor: 'white',
        borderRadius: '4px',
        position: 'relative',
        boxShadow: '0px 0px 24px rgba(0,0,0,0.25)',
        overflow: 'hidden',
        minWidth: '200px',
        color: '#0B2948',
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '4px',
          height: '100%',
          backgroundColor: primaryColour,
          borderRadius: '4px 0 0 4px',
        }}
      />
      <div style={{ padding: '6px 22px' }}>
        <div
          style={{
            marginBottom: '12px',
            borderBottom: `1px solid #d6d6d6`,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: '4px',
          }}
        >
          <img style={{ height: '24px', width: '24px' }} src={resolvedIconURL} />
          <p
            style={{
              margin: '0 0 6px',
              fontWeight: '500 !important',
              fontSize: '15px',
              fontFamily: 'sans-serif',
              textTransform: 'capitalize',
            }}
          >
            {layerName}
          </p>
        </div>

        <table
          style={{
            borderCollapse: 'collapse',
            fontSize: '13px',
            fontFamily: 'sans-serif',
            width: '100%',
          }}
        >
          <tbody>
            {props.map((property) =>
              property.type === 'image' ? (
                <img
                  style={{
                    width: '100%',
                    height: '300px',
                    objectFit: 'cover',
                    borderRadius: '4px',
                    margin: '16px 0',
                    background: 'linear-gradient(90deg,#e8e8e8 25%,#d0d0d0 50%,#e8e8e8 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'live-popup-shimmer 5s infinite',
                  }}
                  src={property.value as string}
                />
              ) : (
                <tr key={property.label}>
                  <td
                    style={{
                      color: '#0B2948',
                      paddingRight: '12px',
                      paddingBottom: '4px',
                      textTransform: 'capitalize',
                      whiteSpace: 'nowrap',
                      verticalAlign: 'top',
                      fontWeight: 600,
                    }}
                  >
                    {property.label.replace(/_/g, ' ')}
                  </td>
                  <td style={{ fontWeight: 400, paddingBottom: '2px' }}>
                    {formatValue(property.value)}
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
      {stackedCount && stackedCount > 1 && (
        <div
          style={{
            borderTop: '1px solid #d6d6d6',
            padding: '6px 22px',
            fontSize: '12px',
            fontFamily: 'sans-serif',
            color: '#555',
            fontStyle: 'italic',
          }}
        >
          {stackedCount} alerts here — click to see all
        </div>
      )}
    </div>
  )
}
